import axios from "axios";

// Create axios instance for admin API
// In production, use relative URL so requests go through nginx proxy
// In development, use environment variable or default to backend port
const isProduction = import.meta.env.MODE === "production";
const baseURL = isProduction
  ? "/api" // In production, nginx will proxy /api to backend
  : import.meta.env.VITE_API_URL || "http://localhost:3100/api";

export const adminApiClient = axios.create({
  baseURL,
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add auth interceptor
adminApiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("admin-token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Add response interceptor for error handling
adminApiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("admin-token");
      window.location.href = "/admin/login";
    }
    return Promise.reject(error);
  },
);
